module.exports = __webpack_public_path__ + "img/Ariadna.f12ab869.webp";